import { useContext } from 'react'
import { EventContext } from './EventContext'

const useEventContext = () => useContext(EventContext)

export default useEventContext
